import type { FC, SVGProps } from 'react';

import { HashtagIcon } from '@heroicons/react/24/outline';

import EnvelopeSimple from '../icon/EnvelopeSimple';
import PlayCircle from '../icon/PlayCircle';

type CommunityChannelIconProps = Pick<SVGProps<SVGSVGElement>, 'className' | 'aria-hidden'>;

export const getCommunityChannelIcon = (slug: string | null | undefined): FC<CommunityChannelIconProps> => {
  if (slug === 'newsletter' || slug === 'newsletters') return EnvelopeSimple;
  if (slug === 'podcasts') return PlayCircle;
  return HashtagIcon;
};
